import {
  ACCOUNT_CANCELLED_ORDERS_PATH,
  ACCOUNT_ORDER_HISTORY_PATH,
  ACCOUNT_UPCOMING_ORDERS_PATH,
} from '@/constants/paths';
import { Card } from '@design-system/Card';
import { Link } from '@design-system/Link';
import { List, ListItem } from '@design-system/List';

const ORDER_ITEMS = [
  { label: 'Future Orders', path: ACCOUNT_UPCOMING_ORDERS_PATH },
  { label: 'Cancelled Orders', path: ACCOUNT_CANCELLED_ORDERS_PATH },
  { label: 'Order History', path: ACCOUNT_ORDER_HISTORY_PATH },
] as const;

export const AccountComponentizedOrdersSection = () => {
  return (
    <div className="flex flex-col" data-testid="accountComponentized-orders">
      <span
        className="typography-h2 text-primary mb-6"
        data-testid="accountComponentized-ordersTitle"
      >
        Orders
      </span>

      <Card data-testid="accountComponentized-ordersCard">
        <List data-testid="accountComponentized-ordersList">
          {ORDER_ITEMS.map(({ label, path }) => (
            <ListItem
              key={label}
              asChild
              data-testid={`accountComponentized-ordersItem-${label.toLowerCase().replace(/\s+/g, '')}`}
            >
              <Link to={path}>{label}</Link>
            </ListItem>
          ))}
        </List>
      </Card>
    </div>
  );
};
